'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _lang = require('lodash/lang');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Base class for input components.
 * @extends {Component}
 */
var InputComponent = function (_React$Component) {
  _inherits(InputComponent, _React$Component);

  function InputComponent() {
    _classCallCheck(this, InputComponent);

    return _possibleConstructorReturn(this, (InputComponent.__proto__ || Object.getPrototypeOf(InputComponent)).apply(this, arguments));
  }

  _createClass(InputComponent, [{
    key: 'generateValidationState',


    /**
     * Returns the validationState prop for react-bootstrap input components.
     * @param {Object} field - The Redux Form field that is being validated.
     * @param {String|null} [successState=null] - Value for validationState when no errors are present.
     * @returns {String|null} The validationState prop value.
     */
    value: function generateValidationState(field) {
      var successState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      return field.touched && field.error ? 'error' : successState;
    }

    /**
     * Returns an error for the given field.
     * @param {Object} field - The Redux Form field that is being validated.
     * @param {Function|null} [wrapperComponent=HelpBlock] - Constructor for a React component that will be rendered
     *                                                       with the field's error as a child. Specify null to render
     *                                                       only the error string.
     * @returns {String|Object} Error string, or a React element wrapping it.
     */

  }, {
    key: 'generateError',
    value: function generateError(field) {
      var wrapperComponent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _reactBootstrap.HelpBlock;

      if (field.touched && field.error) {
        // workaround for JSX compilation
        var Wrapper = wrapperComponent;

        return wrapperComponent ? _react2.default.createElement(
          Wrapper,
          null,
          field.error
        ) : field.error;
      }

      return '';
    }
  }]);

  return InputComponent;
}(_react2.default.Component);

InputComponent.propTypes = {
  hasExpandableHint: _react2.default.PropTypes.bool,
  expandableHintId: _react2.default.PropTypes.string,
  expandableHintTitle: _react2.default.PropTypes.string,
  expandableHintContent: _react2.default.PropTypes.string,
  expandableHintIsRawHtml: function expandableHintIsRawHtml(props, propName) {
    if (props.hasExpandableHint && (0, _lang.isUndefined)(props[propName])) {
      return new Error(propName + ' is required when hasExpandableHint is true.');
    }
    return undefined;
  },
  isDynamic: _react2.default.PropTypes.bool,
  dynamicFieldIndex: function dynamicFieldIndex(props, propName) {
    if (props.isDynamic && (0, _lang.isUndefined)(props[propName])) {
      return new Error(propName + ' is required when isDynamic is true.');
    }
    return undefined;
  },
  isStatic: _react2.default.PropTypes.bool,
  inputId: _react2.default.PropTypes.string.isRequired,
  inputLabel: _react2.default.PropTypes.string.isRequired,
  inputComponent: _react2.default.PropTypes.func.isRequired,
  inputComponentField: _react2.default.PropTypes.object,
  inputComponentProps: _react2.default.PropTypes.object,
  inputComponentChildren: _react2.default.PropTypes.any
};
InputComponent.defaultProps = {
  hasExpandableHint: false,
  isDynamic: false,
  dynamicFieldIndex: ''
};
exports.default = InputComponent;


//////////////////
// WEBPACK FOOTER
// ./src/v2/components/input/InputComponent.jsx
// module id = 408
// module chunks = 0